import React from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import { Layout } from "../Components";
import Errorpage from "../Components/Errorpage";
import { roleBasedRoutes } from "../config/roleBasedRoutes";
import { ProtectedRoutes } from "../config/protectedRoutes";

import SignUp from "../Pages/Auth/SignUp";
import Login from "../Pages/Auth/Login";
import ForgotPassword from "../Pages/Auth/ForgotPassword";
import ResetPassword from "../Pages/Auth/ResetPassword";
import OtpAuthentication from "../Pages/Auth/OTPAuthentication";
import ResetPasswordSuccess from "../Pages/Auth/ResetPasswordSuccess";

const Authenticatedroutes = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <Errorpage />,
    children: [
      { index: true, element: <Navigate to='/dashboard' replace={true} /> },
      ...roleBasedRoutes[1].map((route) => ({
        path: route.path,
        element: React.createElement(ProtectedRoutes(route.element, route.allowedRoles)),
      })),
      { path: "*", element: <Navigate to='/dashboard' replace={true} /> },
    ],
  },
]);

const UnAuthenticatedRoutes = createBrowserRouter([
  { index: true, element: <Navigate to='/login' replace={true} /> },
  { path: "/login", element: <Login />, errorElement: <Errorpage /> },
  {
    path: "/new-admin/:token",
    element: <SignUp />,
    errorElement: <Errorpage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
    errorElement: <Errorpage />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
    errorElement: <Errorpage />,
  },
  {
    path: "/otp",
    element: <OtpAuthentication />,
    errorElement: <Errorpage />,
  },
  {
    path: "/reset-success",
    element: <ResetPasswordSuccess />,
    errorElement: <Errorpage />,
  },
  { path: "*", element: <Navigate to='/login' replace={true} /> },
]);

export { Authenticatedroutes, UnAuthenticatedRoutes };
